import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Appends ?action=login to a studio URL so pre-provisioned users see the
 * Sign In modal instead of the default Sign Up modal.
 */
export function buildStudioLoginUrl(baseUrl: string | null | undefined): string | null {
  if (!baseUrl) return null;
  try {
    const url = new URL(baseUrl);
    url.searchParams.set("action", "login");
    return url.toString();
  } catch {
    return baseUrl;
  }
}

/** Safely convert a Firestore Timestamp, date string, or unknown into a Date. */
export function toDate(ts: unknown): Date | null {
  if (!ts) return null;
  if (
    typeof ts === "object" &&
    ts !== null &&
    "toDate" in ts &&
    typeof (ts as { toDate: unknown }).toDate === "function"
  ) {
    return (ts as { toDate: () => Date }).toDate();
  }
  if (typeof ts === "string") return new Date(ts);
  return null;
}
